import talentonLogo from "../images/logo/to-logo.svg";
import juntoLogo from "../images/logo/junto-logo.svg";
import logoChristmas from "../images/logo/logoChristmas.svg";

export const isMvpEnv = () => process.env.REACT_APP_ENV_TYPE === "mvp";

/**
 * App brand logo. Uses Junto when REACT_APP_ENV_TYPE=mvp.
 * Optional christmas variant is ignored in MVP.
 */
export const getBrandLogo = ({ christmas = false } = {}) => {
  if (isMvpEnv()) return juntoLogo;
  if (christmas) return logoChristmas;
  return talentonLogo;
};

export const getBrandName = () => (isMvpEnv() ? "Junto" : "TalentOn");

export const getBrandLogoAlt = () => getBrandName();
